/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DataTypeFromJSON, DataTypeToJSON, InternalTagTypeFromJSON, InternalTagTypeToJSON, NumberFormatFromJSON, NumberFormatToJSON, NumberValidationFromJSON, NumberValidationToJSON, RollupTypeFromJSON, RollupTypeToJSON, TagTypeFromJSON, TagTypeToJSON, } from './';
export function TagRepresentationFromJSON(json) {
    return TagRepresentationFromJSONTyped(json, false);
}
export function TagRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        type: TagTypeFromJSON(json['type']),
        topDownMapping: !exists(json, 'topDownMapping') ? undefined : json['topDownMapping'],
        topDownEnabled: !exists(json, 'topDownEnabled') ? undefined : json['topDownEnabled'],
        internalType: !exists(json, 'internalType') ? undefined : InternalTagTypeFromJSON(json['internalType']),
        rollupType: !exists(json, 'rollupType') ? undefined : RollupTypeFromJSON(json['rollupType']),
        description: json['description'],
        jsonData: json['jsonData'],
        expression: !exists(json, 'expression') ? undefined : json['expression'],
        ParentId: json['ParentId'],
        connectedTagIds: !exists(json, 'connectedTagIds') ? undefined : json['connectedTagIds'],
        dimensionTagIds: !exists(json, 'dimensionTagIds') ? undefined : json['dimensionTagIds'],
        active: json['active'],
        order: json['order'],
        numberFormat: !exists(json, 'numberFormat') ? undefined : NumberFormatFromJSON(json['numberFormat']),
        dataType: !exists(json, 'dataType') ? undefined : DataTypeFromJSON(json['dataType']),
        numberValidation: !exists(json, 'numberValidation')
            ? undefined
            : NumberValidationFromJSON(json['numberValidation']),
        defaultValue: !exists(json, 'defaultValue') ? undefined : json['defaultValue'],
        optimizeCalculation: !exists(json, 'optimizeCalculation') ? undefined : json['optimizeCalculation'],
        readonly: !exists(json, 'readonly') ? undefined : json['readonly'],
        calculateOnDemand: !exists(json, 'calculateOnDemand') ? undefined : json['calculateOnDemand'],
        zConstraint: !exists(json, 'zConstraint') ? undefined : json['zConstraint'],
        usedInTagIds: !exists(json, 'usedInTagIds') ? undefined : json['usedInTagIds'],
        fromVersionTagId: !exists(json, 'fromVersionTagId') ? undefined : json['fromVersionTagId'],
        toAccountTagId: !exists(json, 'toAccountTagId') ? undefined : json['toAccountTagId'],
        toVersionTagId: !exists(json, 'toVersionTagId') ? undefined : json['toVersionTagId'],
    };
}
export function TagRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        type: TagTypeToJSON(value.type),
        topDownMapping: value.topDownMapping,
        topDownEnabled: value.topDownEnabled,
        internalType: InternalTagTypeToJSON(value.internalType),
        rollupType: RollupTypeToJSON(value.rollupType),
        description: value.description,
        jsonData: value.jsonData,
        expression: value.expression,
        ParentId: value.ParentId,
        connectedTagIds: value.connectedTagIds,
        dimensionTagIds: value.dimensionTagIds,
        active: value.active,
        order: value.order,
        numberFormat: NumberFormatToJSON(value.numberFormat),
        dataType: DataTypeToJSON(value.dataType),
        numberValidation: NumberValidationToJSON(value.numberValidation),
        defaultValue: value.defaultValue,
        optimizeCalculation: value.optimizeCalculation,
        readonly: value.readonly,
        calculateOnDemand: value.calculateOnDemand,
        zConstraint: value.zConstraint,
        usedInTagIds: value.usedInTagIds,
        fromVersionTagId: value.fromVersionTagId,
        toAccountTagId: value.toAccountTagId,
        toVersionTagId: value.toVersionTagId,
    };
}
